import { setArchivedListFailed, setArchivedListPending, setArchivedListSucceed } from './actions';
import { IArchivedListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchChatsV2, IFetchChatsV2ParamsRequest } from '../../services/chatsList';
import { IChat } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { setRoute } from '../route';

/**
 * Получить список архивных чатов
 */
export const getArchivedChatsV2 =
  ({ timestampArchive }: IArchivedListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      chatList: { chats },
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setArchivedListPending({ timestampArchive }));

    const { status, filterBy } = getQueryParamsFetchChatsList('archive');

    const parameters: IFetchChatsV2ParamsRequest = {
      timestamp: timestampArchive,
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const archivedChats = await fetchChatsV2(context, {
      parameters,
    });

    if (archivedChats === null) {
      dispatch(setArchivedListFailed());

      return;
    }

    // FIXME: хз, что здесь происходит
    const archivedChatsVisible =
      chats.filter((chat: IChat) => chat.status === 'archived').length + archivedChats.length;

    const filteredChats = archivedChatsVisible ? archivedChats : [];

    dispatch(setArchivedListSucceed(filteredChats));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(
      setRoute({ route: ERoute.Archive, cleanRemovedFromArchiveChatId: true, cleanRemovedFromSpamChatId: true }),
    );
  };
